import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {ClientTypeSelector} from '../pages/ordini_noleggio-vendita/Inserisci_ordine/ClientTypeSelector'
//import {Inserisci_prove_gratuite} from '../pages/prove_gratuite/Inserisci_prova_gratuita/Inserisci_prova_gratuita'
import {InserisciVisoreInStock} from '../pages/ordini_noleggio-vendita/Inserisci_visore_in_stock/Inserisci_visore_in_stock'
import {InserisciPianoAbbonamento} from '../pages/ordini_noleggio-vendita/Inserisci_piano_abbonamento/Inserisci_piano_abbonamento'
import {InserisciIntermediario} from '../pages/ordini_noleggio-vendita/Inserisci_intermediario/Inserisci_intermediario'
import {InserisciSimulazione} from '../pages/gestione_simulazioni/Inserisci_simulazione/Inserisci_simulazione'
import {GestioneUtenti} from '../pages/console_admin/Gestione_utenti'
//import {Stato_prove_gratuite} from '../pages/prove_gratuite/Stato_ordini'
import {StatoOrdini} from '../pages/ordini_noleggio-vendita/Stato_ordini'
import {StatisticheOrdini} from '../pages/ordini_noleggio-vendita/Statistiche/Statistiche_ordini'
import {StatisticheOrdini2} from '../pages/ordini_noleggio-vendita/Statistiche/Statistiche_ordini_2'
//import {StatoOrdiniContabilita} from '../pages/ordini_noleggio-vendita/Stato_ordini_contabilita'
import {LibroMastro} from '../pages/gestione_visori/Libro_mastro'
import {StatoSimulazioni} from '../pages/gestione_simulazioni/Stato_gestione_simulazioni'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {Login} from '../modules/auth/components/Login'

const PrivateRoutes = () => {
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='login' element={<Login />} />
        <Route path='inserisci-ordine' element={<ClientTypeSelector />} />
        <Route path='stato-ordini' element={<StatoOrdini />} />
        <Route path='statistiche-ordini-in-scadenza' element={<StatisticheOrdini />} />
        <Route path='statistiche-ordini-entrati-nonrinnovati' element={<StatisticheOrdini2 />} />
        {/*<Route path='inserisci-prove-gratuite' element={<Inserisci_prove_gratuite />} />*/}
        {/*<Route path='stato-prove-gratuite' element={<Stato_prove_gratuite />} />*/}
        {/*<Route path='panoramica' element={<StatoOrdiniContabilita />} />*/}
		    <Route path='inserisci-visore' element={<InserisciVisoreInStock />} />
        <Route path='libro-mastro' element={<LibroMastro />} />
        <Route path='inserisci-simulazione' element={<InserisciSimulazione />} />
        <Route path='stato-simulazioni' element={<StatoSimulazioni />} />
		    <Route path='inserisci-piano-abbonamento' element={<InserisciPianoAbbonamento />} />
		    <Route path='inserisci-intermediario' element={<InserisciIntermediario />} />
        <Route path='gestione-utenti' element={<GestioneUtenti />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
